if (!customElements.get('pdp-above-carousel')) {
  class PdpAboveCarousel extends HTMLElement {
    constructor() {
      super();
      this.tileType = this.dataset.tileType || 'PDP';
      this.variantId = this.dataset.variantId;
      this.recNumber = 20;
      this.indexPrefix = this.dataset.prefix;
      this.currentIndex = `${this.indexPrefix}products${getSuffix()}`;

    }

    connectedCallback() {
      if (!this.variantId) {
        this.closest('[data-pdp-carousel]')?.classList.add('hidden');
        return;
      }
      
      poll(() => {
        return window.algoliasearch;
      }, 10000, 150).then(() => {
        this.init();
      }) 
    }
    
    init() {

      if (!document.referrer.includes(location.hostname)) {
        const el = document.querySelector('[data-pdp-carousel]');
        el.classList.remove('hidden');
      }
  

      if (!this.variantId) return;
      const client = window.algoliasearch('B8RIKEI9OC', '307ccfad891594b0e4b982aa6a862676');
      this.locale = this.dataset.locale == 'false' ? false : this.dataset.locale  

      client.getRelatedProducts([
        {
          indexName: this.currentIndex,
          objectID: this.variantId,
        },
      ])
      .then(({ results }) => {
        this.renderResults(results[0]?.hits);
      })
      .catch(err => {
        console.error(err);
        this.closest('[data-pdp-carousel]')?.classList.add('hidden');
      });
    }
    
    renderResults(products) {
      const filteredProducts = products.filter((product) => product.inventory_available !== false && !product.tags.find((tag) => tag === 'base-product' || tag === 'hide-product'));
      if (filteredProducts.length < 1 || !filteredProducts) {
        this.closest('[data-pdp-carousel]').classList.add('hidden');
        return;
      }
      this.innerHTML = `
        <div class="relative z-[1]">
          <swiper-carousel
            data-space-between="8"
            data-slides-per-view-tablet="5" 
            data-slides-per-view-mobile="2.3"
            data-slides-per-view="8"
            data-external-nav-buttons="pdp-top-slider"
            class="w-full"
          >
            <button data-prev="pdp-top-slider" class="button-slider disabled:hidden absolute left-0 top-1/2 -translate-y-1/2 z-10 border-none hover:bg-transparent px-4" data-prev>
              <svg class="transform -scale-x-100" xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <button data-next="pdp-top-slider" class="button-slider disabled:hidden absolute right-0 top-1/2 -translate-y-1/2 z-10 border-none hover:bg-transparent px-4" data-next>
              <svg xmlns="http://www.w3.org/2000/svg" width="10" height="18" viewBox="0 0 10 18" fill="none">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M1.60926 0L0 1.72611L6.78148 9L0 16.2739L1.60926 18L10 9L1.60926 0Z" fill="black"/>
              </svg>
            </button>
            <div class="swiper-wrapper">
              ${filteredProducts.map((product) => `
                <div class="swiper-slide">
                  <intersection-loader 
                    data-url="/products/${product.handle}" 
                    data-section-id="product-mini-tile"
                    class="aspect-[16/19]"
                  ></intersection-loader>                    
                </div>
              `).join('')}
            </div>
          </swiper-carousel>
        </div>
      `;
    }
  }

  customElements.define('pdp-above-carousel', PdpAboveCarousel);
}